import {useMemo} from 'react'
import {useGameStore} from '../GameStoreContext'
import {usePlayerValidators} from './usePlayerValidators'
import {MechanicValidatorCityWall} from '@colonist/game-mechanic-validators'
import {useMapValidator} from './useMapValidator'

export const useMechanicValidatorCityWall = () => {
    const {playerValidators} = usePlayerValidators()
    const mapValidator = useMapValidator()
    const mechanicCityWallState = useGameStore((state) => state.gameState.mechanicCityWallState)

    return useMemo(() => {
        if(!mechanicCityWallState) return undefined
        return new MechanicValidatorCityWall(playerValidators, mapValidator, mechanicCityWallState)
    }, [playerValidators, mapValidator, mechanicCityWallState])
}

